import { Chip, Tooltip } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import DdiInfo from "./DdiInfo";
import DgiInfo from "./DgiInfo";
import {Consts} from "../pages/consts";

const InteractionsChip = ({ label, title, color, drug }) => {
  const { t } = useTranslation();
  const [showInfo, setShowInfo] = useState(false);

  const onChipClicked = () => {
    if (color !== Consts.GREY) {
      setShowInfo(true);
    }
  };

  return (
    <div className="w3-half w3-padding-small">
      {(showInfo && label === t("ddi")) && (
        <DdiInfo
          showInfo={showInfo}
          setShowInfo={setShowInfo}
          drug={drug}
        />
      )}
      {(showInfo && label === t("dgi")) && (
        <DgiInfo showInfo={showInfo} setShowInfo={setShowInfo} drug={drug} />
      )}
      <Tooltip
        title={color === Consts.GREY ? `${t("nothing_found")}` : `${title} (${ t("click_it") })` }
        placement="top"
        componentsProps={{
         tooltip: {
           sx: {
             fontSize: '1.3rem',
           },
         },
       }}
      >
        <Chip
          label={<div className="interactions-chip-label">{ label }</div>}
          sx={{
            backgroundColor: color,
            minHeight: "52px",
            width: "100%",
            maxWidth: "none",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 auto",
            '& .MuiChip-label': {
              color: color === Consts.YELLOW ? "#1565a0" : Consts.WHITE,
              fontSize: "1rem",
              fontWeight: 700,
              lineHeight: 1.2,
              paddingLeft: "8px",
              paddingRight: "8px"
            }
          }}
          onClick={onChipClicked}
        />
      </Tooltip>
    </div>
  );
};

export default InteractionsChip;
